import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {Router} from '@angular/router';

export interface Menu {
    name: string;
    iconClass: string;
    checked: boolean;
    active: boolean;
    submenu: { name: string, key: string, checked: boolean, icon: string }[];
}

export interface Config {
    // selector?: String,
    multi?: boolean;
}

@Component({
    selector: 'app-deployment-plan-menu',
    templateUrl: './deployment-plan-menu.component.html',
    styleUrls: ['./deployment-plan-menu.component.scss']
})
export class DeploymentPlanMenuComponent implements OnInit {

    @Input() options;
    @Input() showFiller = false;
    @Input() menus: any;
    @Input() deploymentPlan: any;
    @Input() defaultActiveMenu: any;
    @Input() isWebSockedConnectionEstablished = false;
    @Output() menuItemSelected: EventEmitter<any> = new EventEmitter<any>();
    @Output() deployOneAPI: EventEmitter<any> = new EventEmitter<any>();
    @Output() transform: EventEmitter<any> = new EventEmitter<any>();
    @Output() showLogs: EventEmitter<any> = new EventEmitter<any>();
    @Output() goBack: EventEmitter<any> = new EventEmitter<any>();
    config: Config;
    allChecked = [];

    constructor(public router: Router) {
    }

    ngOnInit() {
        this.config = this.mergeConfig(this.options);
        if (this.menus && this.menus.length) {
            for (const menu of this.menus) {
                menu['active'] = true;
            }
        }
        for (let i = 0; i < this.menus.length; i++) {
            this.allChecked[i] = this.menus[i].submenu.filter(t => t.checked).length ===  this.menus[i].submenu.length;
        }

    }

    mergeConfig(options: Config) {
        const config = {
            // selector: '#accordion',
            multi: true
        };

        return {...config, ...options};
    }

    toggle(index: number) {
        if (!this.config.multi) {
            this.menus.filter(
                (menu, i) => i !== index && menu.active
            ).forEach(menu => menu.active = !menu.active);
        }

        this.menus[index].active = !this.menus[index].active;
    }

    getId(id) {
        if (id !== '') {
            const str = id.split(' ').join('');
            return '#' + str;
        }
        return '';
    }

    onItemSelected(item, parentMenuName, itemName) {
        $('.submenu li').removeClass('active');
        $(item.target).addClass('active');
        this.menuItemSelected.emit({parent: parentMenuName, child: itemName});
        this.defaultActiveMenu = itemName;
    }

    updateAllComplete(index, subIndex, checked) {
        this.allChecked[index] = this.menus[index].submenu != null && this.menus[index].submenu.every(t => t.checked);
        this.updateDeploymentPlan(index, this.menus[index].submenu[subIndex], checked);
    }

    deploySingleAPI(submenu, i) {
        this.deployOneAPI.emit({menu: submenu, index : i});
    }

    someComplete(index): boolean {
        if (this.menus[index].submenu == null) {
            return false;
        }
        return this.menus[index].submenu.filter(t => t.checked).length > 0 && !this.allChecked[index];
    }

    setAll(checked: boolean, index) {
        this.allChecked[index] = checked;
        if (this.menus[index].submenu == null) {
            return;
        }
        this.menus[index].submenu.forEach(t => {
            t.checked = checked;
            this.updateDeploymentPlan(index, t, checked);
        });
    }

    updateDeploymentPlan(index, submenu, checked) {
        if (index === 0) {
            this.deploymentPlan.entityDeploymentPlans[submenu.planIndex].deploy_api = checked;
            if (this.deploymentPlan.entityDeploymentPlans[submenu.planIndex].isAvailable) {
                this.deploymentPlan.entityDeploymentPlans[submenu.planIndex].override_api = checked;
            } else {
                this.deploymentPlan.entityDeploymentPlans[submenu.planIndex].override_api = false;
            }
        } else {
            this.deploymentPlan.executorModelDeploymentPlans[submenu.planIndex].deploy_api = checked;
            if (this.deploymentPlan.executorModelDeploymentPlans[submenu.planIndex].isAvailable) {
                this.deploymentPlan.executorModelDeploymentPlans[submenu.planIndex].override_api = checked;
            } else {
                this.deploymentPlan.executorModelDeploymentPlans[submenu.planIndex].override_api = false;
            }
        }
    }

    transformAPIs() {
        this.transform.emit(this.menus);
    }

    showLog(parent, child) {
        this.showLogs.emit({parent: parent, child: child});
    }

    refreshComponent() {
        this.goBack.emit();
    }

}



